import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M15 5L5 15M5 5L15 15" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);
